import { BrowserUtils } from '../../utils';

const styles = (
  theme,
  { width, scrollTop, level, position, moreLevels, useLowResolutionStyles } = {}
) => `
& .vds-listbox {
  background-color: ${theme?.vds?.listboxBackground || '#fff'};
  border: 1px solid ${theme?.vds?.listboxBorder || '#b4b4c6'};
  border-radius: ${theme?.vds?.buttonRadius || '2px'};
  display: block;
  list-style: none;
  margin: .1rem 0 0;
  /**
   * 96px = height of 2 items
   * 200px was chosen because its approximately the height of the topbar (with
   *  wrapping) and a text input (with some help text)
   */
  max-height: clamp(96px, 95vh - 200px, 18rem);
  min-width: 80px;
  max-width: 480px;
  width: ${width ? width : '15rem'} !important;
  height: auto;
  overflow-y: auto;
  padding: 0;
  z-index: 1;

  & .vds-listbox {
    overflow-y: auto;
  }
}

& {
  ${
    level > 0
      ? `
        position: absolute;
        width: 100%;
        ${
          width
            ? `${position?.horizontal || 'left'}: ${95 * level}%;`
            : `${position?.horizontal || 'left'}: ${14.5 * level}rem;`
        }
        top: ${scrollTop}px;
      `
      : ''
  }
  ${
    useLowResolutionStyles
      ? `
        left: 0px;
        ${moreLevels ? 'opacity: 0%;' : ''}
      `
      : ``
  }
}

& .cybs-listbox-item-nested {
  padding-right: 0px !important;
  word-break: break-word;
  color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
}

& .cybs-listbox-item-back {
  padding-left: 10px;
}

& .vds-listbox-item-back {
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  padding: 14px 10px;
  display: flex;
  align-items: center;
  &::after {
    top: calc(50% - 0.6125rem);
  }
  padding-right: 0px !important;
  justify-content: left !important;

  &.vds-state--nested-selected,
  &:hover {
    background-color: ${theme?.cybs?.core?.primary ?? '#1434CB'};
    color: ${theme?.cybs?.base?.wcag21?.white ?? '#ffffff'};
    svg use {
      fill:  ${theme?.cybs?.base?.wcag21?.white ?? '#ffffff'};
    }
  }
}

& .vds-listbox-item-back > svg {
  min-width: 1rem;
}

& .cybs-listbox-item-noresults {
  padding: 14px 10px !important;
}

& .vds-listbox-item {
  color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  padding: 14px 10px;
  padding-right: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-word;
  &::after {
    top: calc(50% - 0.6125rem);
  }
}

& .cybs-listbox-item--warning  {
  background-color: rgba(255, 152, 0, 0.10);
}

& .cybs-listbox-item--bordered  {
  &:nth-of-type(1) {
    border-top: 0;
  }
  &:last-of-type {
    border-bottom: 0;
  }
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

& .cybs-listbox-item-section  {
  &:nth-of-type(1) {
    border-top: 0;
  }
  border-bottom: 1px solid ${
    theme?.cybs?.base?.wcag21?.stoneGrey ?? '#62798D'
  };
  border-top: 1px solid ${theme?.cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};
  display: flex;
  font-weight: bold;
  padding: 10px;
  width: 100%;
}

& .vds-listbox-item:focus,
& .vds-listbox-item.vds-state--nested-selected,
& .vds-listbox-item.vds-state--selected {
  background-color: ${theme?.cybs?.core?.primary ?? '#1434CB'};
  outline: 1px dashed transparent;
  outline-offset: -2px;
  color: ${theme?.vds?.listboxTextFocus || '#fff'};
  & > [class^='vds-icon'] use {
    fill: ${theme?.vds?.buttonDefaultTextHover || '#fff'};
  }
  & .cybs-listbox-item-nested {
    color: inherit;
  }
}

&:first-child {
  & .vds-listbox .vds-state--nested-selected.cybs-listbox-item-hasSubitems:not(:hover) {
    background-color: ${theme?.vds?.listboxBackgroundFocus ?? '#1434CB'};
  }
}

& .vds-listbox-item:focus::after,
& .vds-listbox-item.vds-state--selected::after,
& .vds-listbox-item.vds-state--nested-selected.cybs-listbox-item-nested::after,
& .vds-listbox-item.vds-state--focus::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' width='16px' height='16px'%3E%3Cpath fill='${
    BrowserUtils.isHighContrastMode() === 'hc-white' ? `%23000` : `%23fff`
  }' d='M13.9,3.7c-0.4-0.4-1-0.4-1.4,0l-6.6,6.6L3.5,7.9c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l3,3 c0.4,0.4,1,0.4,1.4,0l7.3-7.3C14.3,4.7,14.3,4,13.9,3.7z'/%3E%3C%2Fsvg%3E");;
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: border-box;
  content: '';
  display: block;
  height: 1.25rem;
  position: absolute;
  right: .875rem;
  top: .875rem;
  width: 1.25rem;
}

& .vds-listbox-item.vds-state--nested-selected.cybs-listbox-item-nested.cybs-listbox-item-hasSubitems::after {
  background-image: none;
}

& .vds-listbox-item:active,
& .vds-listbox-item.vds-state--active {
  background-color: ${theme?.vds?.listboxBackgroundActive || '#0F2595'};
  color: ${theme?.vds?.listboxTextActive || '#fff'};
  svg.vds-icon {
    &, & use, & use path {
      fill: white;
    }
  }
}

& .vds-state--disabled:not(.cybs-listbox-item-section) {
  color: ${theme?.vds?.listboxBorder || '#62798D'}
}

& .vds-select--multi .vds-listbox-item {
  padding: .25rem .875rem .25rem 0;
  display: block;
  text-align: left;
}

& .vds-listbox-item:hover:not(.isOpen),
& .vds-select--multi .vds-listbox-item:focus:not(.vds-state--disabled),
& .vds-select--multi .vds-listbox-item:hover:not(.vds-state--disabled),
& .vds-select--multi .vds-listbox-item.vds-state--focus:not(.vds-state--disabled, .vds-state--selected) {
  background-color: ${theme?.vds?.listboxBackgroundHover || '#1434CB'};
  color: ${theme?.vds?.listboxTextHover || '#fff'};

  & .cybs-listbox-item-nested {
    color: inherit;
  }
}

@media all and (-ms-high-contrast:active) {
  & .vds-listbox-item.vds-state--focus,
  & .vds-select--multi .vds-listbox-item:focus:not(.vds-state--disabled),
  & .vds-select--multi .vds-listbox-item.vds-state--focus:not(.vds-state--disabled) {
    outline: 1px dashed;
    border: 1px dashed;
    z-index: 1;
  }
}

.vds-listbox-item.vds-state--nested-selected svg path,
.vds-listbox-item.vds-state--nested-selected svg use,
& .vds-listbox-item:hover:not(.isOpen) svg use {
  fill: ${theme?.vds?.listboxTextHover || '#fff'};
}

& .vds-listbox-item {
  width: 100%;

  &.isOpen {
    background-color: ${theme?.vds?.listboxBackgroundFocus || '#1434CB'};
    & > span {
      color: ${theme?.vds?.listboxTextActive || '#fff'};
    }

  }

  & > [class^='vds-icon'] {
    margin-right: 0.5rem;
    flex-shrink: 0;
  }

  &.isOpen > [class^='vds-icon'] use,
  &:hover > [class^='vds-icon'] use {
        fill: ${theme?.vds?.buttonDefaultTextHover || '#fff'};
      }
    }
  }
}

& .vds-select--multi .vds-listbox-item:focus:not(.vds-state--disabled)::after,
& .vds-select--multi .vds-listbox-item:hover:not(.vds-state--disabled)::after,
& .vds-select--multi .vds-listbox-item.vds-state--focus:not(.vds-state--disabled)::after {
  content: none;
}

& .vds-select--multi .vds-listbox-item .vds-checkbox-label {
  margin-left: .25rem;
  pointer-events: none;
}

& .vds-select--multi .vds-listbox-item .vds-checkbox-label::before {
  background-color: ${theme?.vds?.transparent || 'rgba(0,0,0,0)'};
  border: 0;
  
}

/* Multi select listbox 
*  Selected state
*/
& .vds-select--multi .vds-listbox-item.vds-state--selected:not(.vds-state--focus),
& .vds-select--multi .vds-listbox-item[aria-selected='true']:not(.vds-state--focus):not(:hover) {
  background-color: ${theme?.cybs?.base?.wcag21?.white ?? '#ffffff'};
  outline: none;
  color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
}

& .vds-select--multi .vds-listbox-item.vds-state--selected .vds-checkbox-label::before,
& .vds-select--multi .vds-listbox-item[aria-selected='true'] .vds-checkbox-label::before {
  height: 1.25rem;
  width: 1.25rem;
  left: .625rem;
  top: .625rem;
  box-sizing: border-box;
  border: 0.6125rem solid transparent;
  z-index: 1;
}


& .vds-select--multi .vds-listbox-item .vds-checkbox-label.vds-state--checked::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' width='16px' height='16px'%3E%3Cpath fill='%23${theme?.cybs?.core?.primary?.slice(1) ?? '1434CB'}' d='M13.9,3.7c-0.4-0.4-1-0.4-1.4,0l-6.6,6.6L3.5,7.9c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l3,3 c0.4,0.4,1,0.4,1.4,0l7.3-7.3C14.3,4.7,14.3,4,13.9,3.7z'/%3E%3C%2Fsvg%3E"); // sass-lint:disable-line quotes
  background-color:white;
}

`;

export default styles;
